// extracted by mini-css-extract-plugin
export default {"divider":"k40dfr0j"};